import React from 'react';
import PropTypes from 'prop-types';
import MuiTable from '@mui/material/Table';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
});

class Table extends React.Component {
  static propTypes = {
    /** Children for table to render */
    children: PropTypes.node.isRequired,
  };

  render() {
    const { children } = this.props;

    return <MuiTable>{children}</MuiTable>;
  }
}

export default styled(Table)(styles);
